import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export const DEFAULT_USER = {
    id: 1,
    isAverageUser: false,
    isDescendantUserWithAuth: false,
    isDescendantUserWithoutAuth: false,
    isInternal: false,
    isSuperOrganizationManager: false,
    result: null,
    shareFrom: "R1VFU1Q=",
    success: true,
    username: "GUEST",
    screenName: '',
}
export const enaeaSlice = createSlice({
    name: "enaea",
    initialState: {
        userinfo: DEFAULT_USER
    },
    reducers: {
        setUserInfo: (state, action: PayloadAction<typeof DEFAULT_USER>) => {
            state.userinfo = action.payload;
        }
    }
});
export const {setUserInfo} = enaeaSlice.actions;
export default enaeaSlice.reducer;
